type RecommendedProduct = {
  id?: number | string
  shopify_id?: number | string
  title?: string
  handle?: string
  featured_image_url?: string | null
  url?: string
}

type RecommendationsResponse = {
  recommendations?: unknown[]
  products?: RecommendedProduct[]
}

const MODAL_ID = 'sky-pilot-recommendations-overlay'
const STYLE_ID = 'sky-pilot-recommendations-styles'

const PLACEHOLDER_SVG = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="9" cy="9" r="2"/><path d="M21 15l-5-5L5 21"/></svg>`

const ensureStyles = () => {
  if (document.getElementById(STYLE_ID)) return

  const style = document.createElement('style')
  style.id = STYLE_ID
  style.textContent = `
    #${MODAL_ID} {
      --sky-pilot-ink: #111111;
      --sky-pilot-ink-soft: #4b4b4b;
      --sky-pilot-muted: #8a8a8a;
      --sky-pilot-border: #e6e6e6;
      --sky-pilot-panel: #fafafa;
      position: fixed;
      inset: 0;
      z-index: 2147483646;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 20px;
      background: rgba(17, 17, 17, 0.5);
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif;
      box-sizing: border-box;
    }
    #${MODAL_ID} *, #${MODAL_ID} *::before, #${MODAL_ID} *::after { box-sizing: border-box; }
    #${MODAL_ID} .sky-pilot-recommendations-modal {
      background: #fff;
      color: var(--sky-pilot-ink);
      border-radius: 14px;
      max-width: 560px;
      width: 100%;
      max-height: 86vh;
      overflow-y: auto;
      box-shadow: 0 24px 60px rgba(0, 0, 0, 0.18);
    }
    #${MODAL_ID} .sky-pilot-recommendations-modal-head {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 12px;
      padding: 22px 24px 4px;
    }
    #${MODAL_ID} .sky-pilot-recommendations-eyebrow {
      font-size: 11px;
      font-weight: 700;
      letter-spacing: 0.06em;
      text-transform: uppercase;
      color: var(--sky-pilot-muted);
      margin-bottom: 4px;
    }
    #${MODAL_ID} .sky-pilot-recommendations-heading {
      font-size: 18px;
      font-weight: 600;
      margin: 0;
      line-height: 1.3;
    }
    #${MODAL_ID} .sky-pilot-recommendations-close {
      background: none;
      border: none;
      cursor: pointer;
      color: var(--sky-pilot-muted);
      width: 30px;
      height: 30px;
      border-radius: 50%;
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      line-height: 1;
      padding: 0;
    }
    #${MODAL_ID} .sky-pilot-recommendations-close:hover {
      background: var(--sky-pilot-panel);
      color: var(--sky-pilot-ink);
    }
    #${MODAL_ID} .sky-pilot-recommendations-sub {
      font-size: 13px;
      color: var(--sky-pilot-ink-soft);
      padding: 0 24px 18px;
      margin: 0;
      line-height: 1.4;
    }
    #${MODAL_ID} .sky-pilot-recommendations-list {
      padding: 0 24px 24px;
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
    #${MODAL_ID} .sky-pilot-recommendations-item {
      display: flex;
      align-items: center;
      gap: 14px;
      border: 1px solid var(--sky-pilot-border);
      border-radius: 10px;
      padding: 12px;
      text-decoration: none;
      color: inherit;
      background: #fff;
    }
    #${MODAL_ID} .sky-pilot-recommendations-thumb {
      width: 56px;
      height: 56px;
      border-radius: 8px;
      background: var(--sky-pilot-panel);
      border: 1px solid var(--sky-pilot-border);
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #c4c4c4;
      overflow: hidden;
    }
    #${MODAL_ID} .sky-pilot-recommendations-thumb img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
    #${MODAL_ID} .sky-pilot-recommendations-thumb svg {
      width: 24px;
      height: 24px;
    }
    #${MODAL_ID} .sky-pilot-recommendations-item-info {
      flex: 1;
      min-width: 0;
    }
    #${MODAL_ID} .sky-pilot-recommendations-item-title {
      font-size: 14px;
      font-weight: 600;
      line-height: 1.3;
      margin: 0;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    #${MODAL_ID} .sky-pilot-recommendations-buy {
      background: var(--sky-pilot-ink);
      color: #fff;
      border: none;
      border-radius: 6px;
      padding: 8px 14px;
      font-size: 12px;
      font-weight: 600;
      cursor: pointer;
      white-space: nowrap;
      text-decoration: none;
      flex-shrink: 0;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
    #${MODAL_ID} .sky-pilot-recommendations-foot {
      padding: 14px 24px 22px;
      text-align: center;
    }
    #${MODAL_ID} .sky-pilot-recommendations-dismiss {
      font-size: 12px;
      color: var(--sky-pilot-muted);
      text-decoration: underline;
      cursor: pointer;
      background: none;
      border: none;
      padding: 0;
      font-family: inherit;
    }
    @media (max-width: 480px) {
      #${MODAL_ID} {
        padding: 12px;
        align-items: flex-end;
      }
      #${MODAL_ID} .sky-pilot-recommendations-modal {
        max-height: 92vh;
        border-radius: 14px 14px 0 0;
      }
      #${MODAL_ID} .sky-pilot-recommendations-modal-head,
      #${MODAL_ID} .sky-pilot-recommendations-sub,
      #${MODAL_ID} .sky-pilot-recommendations-list,
      #${MODAL_ID} .sky-pilot-recommendations-foot {
        padding-left: 16px;
        padding-right: 16px;
      }
      #${MODAL_ID} .sky-pilot-recommendations-item {
        gap: 10px;
        padding: 10px;
      }
      #${MODAL_ID} .sky-pilot-recommendations-thumb {
        width: 48px;
        height: 48px;
      }
      #${MODAL_ID} .sky-pilot-recommendations-buy {
        padding: 8px 12px;
      }
    }
  `
  document.head.appendChild(style)
}

const closeModal = () => {
  document.getElementById(MODAL_ID)?.remove()
  document.removeEventListener('keydown', handleEscapeKey)
}

const handleEscapeKey = (event: KeyboardEvent) => {
  if (event.key === 'Escape') closeModal()
}

const escapeHtml = (value: string) =>
  value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;')

const showRecommendationsModal = (products: RecommendedProduct[]) => {
  if (!products.length) return

  ensureStyles()
  closeModal()

  const productHtml = products
    .filter((product) => product.url && product.title)
    .map((product) => {
      const thumb = product.featured_image_url
        ? `<img src="${escapeHtml(product.featured_image_url)}" alt="${escapeHtml(product.title || '')}">`
        : PLACEHOLDER_SVG

      return `
        <div class="sky-pilot-recommendations-item">
          <div class="sky-pilot-recommendations-thumb">${thumb}</div>
          <div class="sky-pilot-recommendations-item-info">
            <p class="sky-pilot-recommendations-item-title">${escapeHtml(product.title || '')}</p>
          </div>
          <a href="${escapeHtml(product.url || '')}" class="sky-pilot-recommendations-buy" target="_top" rel="noopener">View</a>
        </div>
      `
    })
    .join('')

  if (!productHtml) return

  const overlay = document.createElement('div')
  overlay.id = MODAL_ID
  overlay.setAttribute('role', 'dialog')
  overlay.setAttribute('aria-modal', 'true')
  overlay.setAttribute('aria-label', 'You may also like')
  overlay.innerHTML = `
    <div class="sky-pilot-recommendations-modal">
      <div class="sky-pilot-recommendations-modal-head">
        <div>
          <div class="sky-pilot-recommendations-eyebrow">Before you go</div>
          <h3 class="sky-pilot-recommendations-heading">You may also like</h3>
        </div>
        <button type="button" class="sky-pilot-recommendations-close" aria-label="Close">✕</button>
      </div>
      <p class="sky-pilot-recommendations-sub">Based on your download, other customers also picked up:</p>
      <div class="sky-pilot-recommendations-list">
        ${productHtml}
      </div>
      <div class="sky-pilot-recommendations-foot">
        <button type="button" class="sky-pilot-recommendations-dismiss">No thanks, take me to my downloads</button>
      </div>
    </div>
  `

  overlay.addEventListener('click', (event) => {
    if (event.target === overlay) closeModal()
  })
  overlay.querySelector('.sky-pilot-recommendations-close')?.addEventListener('click', closeModal)
  overlay.querySelector('.sky-pilot-recommendations-dismiss')?.addEventListener('click', closeModal)
  document.addEventListener('keydown', handleEscapeKey)

  document.body.appendChild(overlay)
}

/**
 * Build recommendations JSON URL from a download href like:
 * /apps/downloads/downloads/:id?email=...&order_id=...&order_item_id=...
 */
export const recommendationsUrlFromDownloadHref = (href: string): string | null => {
  try {
    const url = new URL(href, window.location.origin)

    if (url.pathname.includes('/preview/')) return null

    const match = url.pathname.match(/^(.*?)\/downloads\/(\d+)$/)
    if (!match) return null

    const prefix = match[1]
    const fileId = match[2]
    if (prefix.endsWith('/downloadable_files')) return null

    const email = url.searchParams.get('email')
    const orderId = url.searchParams.get('order_id')
    const orderItemId = url.searchParams.get('order_item_id')
    if (!email || !orderId || !orderItemId) return null

    // Path only — Shopify app proxy adds shop/signature/logged_in_customer_id on the way through.
    return `${prefix}/orders/${encodeURIComponent(email)}/${orderId}/order_items/${orderItemId}/downloadable_files/${fileId}/recommendations`
  } catch {
    return null
  }
}

const isModifiedClick = (event: MouseEvent) => event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0

const resolveRecommendationsUrl = (anchor: HTMLAnchorElement): string | null => {
  const explicit = anchor.getAttribute('data-recommendations-url')?.trim()
  if (explicit) return explicit

  return null

  // const href = anchor.getAttribute('href')
  // if (!href) return null

  // return recommendationsUrlFromDownloadHref(href) || recommendationsUrlFromDownloadHref(anchor.href)
}

const isDownloadAnchor = (anchor: HTMLAnchorElement) => {
  const href = anchor.getAttribute('href')
  if (!href) return false
  if (href.includes('/downloadable_files/')) return false
  return Boolean(resolveRecommendationsUrl(anchor))
}

const startDownload = (href: string) => {
  const iframe = document.createElement('iframe')
  iframe.style.display = 'none'
  iframe.setAttribute('aria-hidden', 'true')
  iframe.src = href
  document.body.appendChild(iframe)
  window.setTimeout(() => iframe.remove(), 60000)
}

const fetchProducts = async (recommendationsUrl: string): Promise<RecommendedProduct[]> => {
  const response = await fetch(recommendationsUrl, {
    headers: {
      Accept: 'application/json',
    },
    credentials: 'same-origin',
  })
  if (!response.ok) return []

  const data = (await response.json()) as RecommendationsResponse
  return Array.isArray(data.products) ? data.products : []
}

const handleDownloadClick = async (event: MouseEvent, anchor: HTMLAnchorElement) => {
  if (isModifiedClick(event)) return

  const href = anchor.getAttribute('href')
  if (!href) return

  const recommendationsUrl = resolveRecommendationsUrl(anchor)
  if (!recommendationsUrl) return

  event.preventDefault()
  event.stopPropagation()

  // Start file download immediately; stay on page so the popup can render.
  // startDownload(href)
  window.open(href, '_blank')

  // File show page already renders recommendations server-side — avoid duplicate UI.
  if (document.querySelector('.sky-pilot-recommended-products')) return

  try {
    const products = await fetchProducts(recommendationsUrl)
    showRecommendationsModal(products)
  } catch (error) {
    console.warn('[SkyPilot] Failed to load recommendations', error)
  }
}

let initialized = false

export const initializeDownloadRecommendations = () => {
  if (initialized) return
  initialized = true

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target
      if (!(target instanceof Element)) return

      const anchor = target.closest('a')
      if (!(anchor instanceof HTMLAnchorElement)) return
      if (!isDownloadAnchor(anchor)) return

      void handleDownloadClick(event, anchor)
    },
    true
  )
}
